import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Button } from '@abyss/web/ui/Button';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStorage } from 'usehooks-ts';

import { setZoomLevel } from '../../utils/amazon.map.utils';
import { Constants } from '../Constants';
import { phoneOnly } from '../ConstantsStyles';
import { getGeoLocationFromStorage } from '../PSXHeader/SearchBar/utils';

type Props = {
  map: any;
};

export const LocateMe = ({ map }: Props) => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);
  const { longitude, latitude } = getGeoLocationFromStorage();
  const [isInUserLocation, setIsInUserLocation] = useState<Boolean>(false);

  const [mapPinCoords] = useSessionStorage(
    Constants.STORAGE_KEYS.SESSION.MAP_PIN_COORDS,
    []
  );

  const handleLocateMe = () => {
    try {
      if (isInUserLocation) {
        // setZoomLevel expects a ref with .current property
        setZoomLevel({ current: map }, mapPinCoords);
      } else {
        // Convert to numbers in case they're strings from storage
        const lng = parseFloat(longitude as any);
        const lat = parseFloat(latitude as any);

        if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
          // Invalid coordinates from storage
          return;
        }
        map.flyTo({
          center: [lng, lat],
          zoom: Constants.DEVICE_LOCATION.ZOOM,
          bearing: 50,
          pitch: 20,
        });
      }
      setIsInUserLocation((previous) => !previous);
    } catch {
      // Error in handleLocateMe
    }
  };

  const iconSize = mobileScreen ? 20.57 : 22;
  const buttonSize = mobileScreen ? '$md' : '$lg';
  return (
    <Button
      aria-label={t('LOCATION_FOCUS_BOX.MY_LOCATION')}
      css={{
        'abyss-button-root': {
          backgroundColor: '$primary2',
          border: 'none',
          boxShadow: '0 2px rgba(25, 25, 26, 0.16)',
        },
      }}
      data-auto-testid="my-location"
      data-testid="my-location"
      onClick={handleLocateMe}
      rounded
      size={buttonSize}
      variant="ghost"
    >
      <IconMaterial color="$neutralGray5" icon="my_location" size={iconSize} />
    </Button>
  );
};
